export default __webpack_public_path__ + "87984f04e8657d3a483ab733a7891e99.svg";